// Kwalificeringsvragen per sector — vaste vragen die een begeleider van Deccos
// bij de onboarding met één schakelaar op een onderzoek aanzet. Ze worden als
// echte QuestionnaireFields in de vragenlijst geschreven, alleen op het eerste
// meetmoment gesteld, en zijn niet te bewerken.
//
// De sleutels (`key` op de set en op elke vraag, `key` op elke optie) worden
// weggeschreven als `QualifyingKey` / `OptionKey`. Daaraan worden de antwoorden
// later herkend — over onderzoeken en organisaties heen, nooit op de vraagtekst.
// Een sleutel wijzigen maakt bestaande antwoorden dus onvindbaar: voeg toe,
// hernoem niet.
//
// Niet hetzelfde als `dataHelpers/sectorContextQuestions.js`: dat zijn
// antwoorden van de organisatie zelf, eenmalig, voor de benchmark. Dit zijn
// vragen aan huishoudens in een vragenlijst.
//
// AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md

/**
 * @typedef {object} QualifyingOption
 * @property {string} key - Vaste sleutel, weggeschreven als `OptionKey`
 * @property {string} label - Tekst van de optie
 */

/**
 * @typedef {object} QualifyingQuestion
 * @property {string} key - Vaste sleutel, weggeschreven als `QualifyingKey`
 * @property {string} question - De vraag zoals de invuller hem leest
 * @property {QualifyingOption[]} options - Antwoordopties, in deze volgorde
 */

/**
 * @typedef {object} QualifyingSet
 * @property {string} key - Sector-slug; ook de `QualifyingKey` van de sectiekop
 * @property {string} label - Tekst bij de schakelaar op het onderzoek
 * @property {string} sectionTitle - Titel van de sectie in de vragenlijst
 * @property {QualifyingQuestion[]} questions
 */

/** @type {QualifyingOption[]} */
const JA_NEE = [
    { key: 'ja', label: 'Ja' },
    { key: 'nee', label: 'Nee' },
]

/** @type {Object<string, QualifyingSet>} */
export const sectorQualifyingQuestions = {
    energiearmoede: {
        key: 'energiearmoede',
        label: 'Kwalificeringsvragen Energiearmoede stellen',
        sectionTitle: 'Kwalificering',
        questions: [
            {
                key: 'energiearmoede.kouTochtVocht',
                question: 'Heeft uw woning last van kou, tocht of vocht?',
                options: JA_NEE,
            },
            {
                key: 'energiearmoede.energierekening',
                question: 'Heeft u moeite om uw energierekening te betalen?',
                options: JA_NEE,
            },
            {
                key: 'energiearmoede.verwarmingLager',
                question: 'Zet u de verwarming weleens lager of uit omdat energie te duur is?',
                options: JA_NEE,
            },
        ],
    },
}

/**
 * De sets die horen bij de sectoren van een organisatie.
 *
 * @param {string[] | null | undefined} sectors - `CompagnyMeta.SelectedSectors`
 * @returns {QualifyingSet[]} Leeg zolang er niets van toepassing is.
 */
export const qualifyingSetsFor = (sectors) => {
    const list = Array.isArray(sectors) ? sectors : []
    return [...new Set(list)]
        .filter((slug) => sectorQualifyingQuestions[slug])
        .map((slug) => sectorQualifyingQuestions[slug])
}

const sectorQualifying = { sectorQualifyingQuestions, qualifyingSetsFor }

export default sectorQualifying
